import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Icon from 'components/Icon';
import Like from 'components/Like';
import Subscribe from 'components/Subscribe';
import FormattedContent from 'components/FormattedContent';
import { is } from 'immutable';
import bemClassName from 'bem-classname';
import uuid from 'uuid';
import Wrapper from './Wrapper';
import { declension } from 'utils/lang';

const className = bemClassName.bind(null, 'card');

const handlers = {};

if(!process.env.IS_NODE) {
  window.addEventListener('resize', e => {
    Object.keys(handlers).forEach(key => handlers[key](e));
  });
}

export default class GoalCard extends React.Component {

  static propTypes = {
    goal: PropTypes.object.isRequired,
    currency: PropTypes.object.isRequired,
    isGuest: PropTypes.bool.isRequired,
    onLike: PropTypes.func.isRequired,
    onSubscribe: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['template', 'goal']),
    onUnsubscribe: PropTypes.func.isRequired,
    wrapperSize: PropTypes.oneOf(['1', '2', '3', '1/2']),
  };

  uuid = uuid.v1();
  state = {
    cut: false,
  };

  componentDidMount() {
    this.handleResize = () => {
      const descrWrapperRect = this.refs.descrWrapper.getBoundingClientRect();
      const descrRect = ReactDOM.findDOMNode(this.refs.descr).getBoundingClientRect();

      this.setState({
        cut: descrWrapperRect.height < descrRect.height,
      });
    };
    handlers[this.uuid] = this.handleResize;
    this.handleResize();
  }

  componentWillUnmount() {
    delete handlers[this.uuid];
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !is(this.props.goal, nextProps.goal) || nextState.cut !== this.state.cut;
  }

  render() {
    const { goal, type = 'goal', currency, wrapperSize } = this.props;
    const { cut } = this.state;

    return (
      <Wrapper size={wrapperSize} className={className(['with-footer', 'full'])}>
        <div className={className('body')}>
          <a href={goal.get('url')} className={className('cover')}>
            <div className={className('cover-w')}>
              <div className={className('img-w', { empty: !goal.get('img') })}
                style={{
                  backgroundColor: goal.get('imgBg'),
                  backgroundImage: `url(${goal.get('img')})`,
                }}
                />

              <div className={className('progrs')}>
                <Icon type="user" /> {goal.get('username')}
              </div>

              <ul className={className('metrics')}>
                <li className={className('metric')}>
                  <Icon type="pen" /> {goal.get('count_posts')}
                </li>
                <li className={className('metric')}>
                  <Icon type="comment" /> {goal.get('count_comments')}
                </li>
              </ul>
            </div>
          </a>
          <div className={className('w')}>
            <a href={goal.get('url')} className={className('link', ['inline'])}>
              <p className={className('cat')}>
                {goal.get('category_name')}
              </p>
              <h3 className={className('title', [goal.get('status')])}>
                <span dangerouslySetInnerHTML={{ __html: goal.get('name') }} />
                {goal.get('status') === 'failed' && <Icon type="fail" className={className('titleIcon')} />}
                {goal.get('status') === 'successful' && <Icon type="success" className={className('titleIcon')} />}
              </h3>
            </a>

            <div className={className('descr', { cut })} ref="descrWrapper">
              <FormattedContent ref="descr">
                {goal.get('descr_short')}
              </FormattedContent>
            </div>
          </div>
        </div>
        <footer className={className('footer', ['goal'])}>
          {(goal.get('is_own') === 0 && type === 'goal') &&
            <Subscribe
              subscribed={parseInt(goal.get('subscription'), 10) > 0}
              counter={goal.get('count_subscriptions')}
              fastSignupParams={{
                subscribe_to_goal: goal.get('id'),
              }}
              onClick={
                parseInt(goal.get('subscription'), 10) > 0
                ? this.props.onUnsubscribe
                : this.props.onSubscribe
              }
              />
          }
          {(goal.get('is_own') > 0 && type === 'goal') &&
            <span style={{ color: '#8D95A0' }}>
              {declension(__('count_subscriptions'), goal.get('count_subscriptions'))}
            </span>
          }

          {type === 'template' &&
            <span
              dangerouslySetInnerHTML={{
                __html: goal.get('price') === '0.00' ? __('free') : `${goal.get('price')} ${currency.sign}`,
              }}
              />
          }

          <Like
            liked={!!Number(goal.get('liked'))}
            disabled={goal.get('is_own')}
            counter={parseInt(goal.get('rating'), 10)}
            onClick={this.props.onLike}
            share
            fastSignupParams={{
              Rating: {
                obj_type: 'goal',
                obj_id: goal.get('id'),
              },
            }}
            fastSignupPosition="right"
            shareOptions={{
              url: goal.get('share_url'),
              descr: goal.get('share_descr'),
              img: goal.get('share_image'),
            }}
            />
        </footer>
      </Wrapper>
    );
  }

}



// WEBPACK FOOTER //
// ./src/react/components/GoalCard/GoalCard.js